// Sections fade up once as they enter the viewport (skipped entirely for reduced motion).
export function initReveal(): void {
  const els = document.querySelectorAll<HTMLElement>('.reveal');
  if (!els.length || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.documentElement.classList.add('js-reveal');
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    },
    { rootMargin: '0px 0px 10% 0px', threshold: 0 },
  );
  for (const el of els) io.observe(el);
}
